import type { AdminSongQuery, AdminUserQuery } from './adminTypes'

function cleanQuery(value: string): string {
  return value.trim().slice(0, 100)
}

export function adminUsersPath(options: AdminUserQuery): string {
  const params = new URLSearchParams({
    page: String(Math.max(0, options.page)),
    size: String(options.size),
    query: cleanQuery(options.query),
    sort: options.sort,
  })
  return `/api/v1/segno/admin/users?${params.toString()}`
}

export function adminSongsPath(options: AdminSongQuery): string {
  const params = new URLSearchParams({
    page: String(Math.max(0, options.page)),
    size: String(options.size),
    includeExpired: String(options.includeExpired),
    includeInactiveShares: String(options.includeInactiveShares),
    query: cleanQuery(options.query),
    sourceType: options.sourceType,
    status: options.status,
    report: options.report,
    sort: options.sort,
  })
  return `/api/v1/segno/admin/songs?${params.toString()}`
}
